/**
 * @deutero/interview-widget — embeddable copilot-style interview widget.
 *
 *   import { init } from "@deutero/interview-widget";
 *   const widget = init({ publishableKey: "dtro_pk_…", surveyId: "…" });
 *   widget.on("complete", () => console.log("done"));
 *
 * Script-tag consumers load /widget/v1/deutero-widget.js instead (see
 * loader.ts), which exposes the same API as window.DeuteroInterview.
 */
import { DeuteroWidget } from "./widget";
import type {
  DeuteroInterviewConfig,
  DeuteroInterviewInstance,
  QuestionView,
  UISpec,
  WidgetEvents,
} from "./types";

export function init(config: DeuteroInterviewConfig): DeuteroInterviewInstance {
  return new DeuteroWidget(config);
}

export { buildUISpec } from "./uispec";
export {
  composeMultiSelect,
  composeRanking,
  composeCardSort,
  composeCardSortState,
  composeOption,
  composeScale,
  PNTA_TEXT,
  NONE_TEXT,
} from "./composer";
export type {
  DeuteroInterviewConfig,
  DeuteroInterviewInstance,
  QuestionView,
  UISpec,
  WidgetEvents,
};

declare global {
  interface Window {
    DeuteroInterview?: { init: typeof init };
  }
}
